import { render, staticRenderFns } from "./TablePartners.vue?vue&type=template&id=26809151&scoped=true"
import script from "./TablePartners.vue?vue&type=script&lang=js"
export * from "./TablePartners.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "26809151",
  null
  ,true
)

export default component.exports